import { types } from 'mobx-state-tree';

export const OnboardingStore = types
  .model('OnboardingStore', {
    selectedOrgId: types.maybe(types.string),
    selectedPlanKey: types.maybe(types.string),
  })
  .actions((self) => ({
    setSelectedOrgId(orgId: string) {
      self.selectedOrgId = orgId;
    },
    setSelectedPlanKey(planKey: string) {
      self.selectedPlanKey = planKey;
    },
    reset() {
      self.selectedOrgId = undefined;
      self.selectedPlanKey = undefined;
    },
  }))
  .views((self) => ({
    get hasSelectedOrg() {
      return self.selectedOrgId != null;
    },
    get hasSelectedPlan() {
      return self.selectedPlanKey != null;
    },
  }));

export const createOnboardingStore = () => {
  return OnboardingStore.create({});
};
